import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.config.productionTip = false

Vue.use(VueYandexMetrika, {
  id: 79630591,
  router: router,
  env: process.env.NODE_ENV
  // other options
})

new Vue({
  vuetify,
  router,
  store,
  data: {
    themeColor: '#fd7e14',
    brownThemeColor: '#C98A55',
  },
  render: h => h(App)
}).$mount('#app')
